(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["armora-collection-description"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-armora-collection-description]').forEach((root)=>{if(root.dataset.initialized==='true')return;root.dataset.initialized='true';const content=root.querySelector('[data-description-content]'),toggle=root.querySelector('[data-description-toggle]'),label=root.querySelector('[data-toggle-label]');if(!content||!toggle||!label)return;toggle.addEventListener('click',()=>{const expanded=toggle.getAttribute('aria-expanded')==='true';content.classList.toggle('is-collapsed',expanded);toggle.setAttribute('aria-expanded',expanded?'false':'true');label.textContent=expanded?toggle.dataset.readMore:toggle.dataset.readLess})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
